module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-wrapper"
  }, [_c('table', {
    ref: _vm.label,
    staticClass: "mdl-data-table",
    attrs: {
      "id": _vm.label
    }
  }, [_c('caption', {
    staticClass: "tableexport-caption"
  }, [_vm._v(_vm._s(_vm.label) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "sub_caption"
  }, [_vm._v("Kön fördelat på ålder")]), _c('br'), _c('download-button', {
    attrs: {
      "table-ref": _vm.table,
      "filename": _vm.label + '_' + _vm.start + '--' + _vm.end + '_Kön_fördelat_på_ålder'
    }
  })], 1), _vm._m(0, false, false), _c('tbody', [_vm._l((_vm.age_ranges), function(range, idx) {
    return _c('tr', [_c('td', {
      staticClass: "mdl-data-table__cell--non-numeric"
    }, [_vm._v(_vm._s(range))]), _c('td', [_vm._v(_vm._s((_vm.cluster[idx].woman || []).length))]), _c('td', [_vm._v(_vm._s((_vm.cluster[idx].man || []).length))]), _c('td', [_vm._v(_vm._s((_vm.cluster[idx].hen || []).length))]), _c('td', {
      staticClass: "sum"
    }, [_vm._v(_vm._s((_vm.cluster[idx].man || []).length + (_vm.cluster[idx].hen || []).length + (_vm.cluster[idx].woman || []).length))])])
  }), _c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric sum"
  }, [_vm._v("Summa")]), _c('td', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sumLengthByKey(_vm.cluster, 'woman')))]), _c('td', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sumLengthByKey(_vm.cluster, 'man')))]), _c('td', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sumLengthByKey(_vm.cluster, 'hen')))]), _c('td', {
    staticClass: "sum"
  }, [_vm._v(_vm._s(_vm.sumLengthByKey(_vm.cluster, 'man') + _vm.sumLengthByKey(_vm.cluster, 'woman') + _vm.sumLengthByKey(_vm.cluster, 'hen')))])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Åldersintervall")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Kvinnor")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Män")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Annat")]), _c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Totalt")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-528eff0b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatisticsTableFull.vue
// module id = 518
// module chunks = 1